import React from 'react';
import {IndexLink, Link} from 'react-router';
import {connect} from 'react-redux';
import * as commonApi from '../../../api/common-api';
import Loading from 'react-loading';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

var querystring = require('querystring');
var Progress = require('react-progressbar');
var progress_val = 0;
const file_limit = 25 * 1024 * 1024;
var uploading = false;
var relOptions = [
    {value: '0', label: 'Relevance'},
    {value: '1', label: '5 Star only'},
];


class CommentBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {comment: "", file_upload: undefined, preview: ""};
    }

    componentDidMount() {
        if (this.props.getInput != undefined) {
            this.props.getInput(this.refs.input);
        }
    }

    handleFileUpload(event) {
        if (event.target.files.length > 0) {
            var fileUpload = event.target.files[0];
            if (fileUpload.size > file_limit) {
                commonApi.showAlert("Max file size is 25MB!");
                this.refs.file_input.value = '';
                return;
            }
            var Extension = fileUpload.name.substring(fileUpload.name.lastIndexOf('.') + 1).toLowerCase();
            var imageExt = ['jpg', 'jpeg', 'png', 'gif'];
            if (imageExt.indexOf(Extension) != -1) {
                var reader = new FileReader();
                reader.onloadend = () => {
                    this.setState({
                        file_upload: fileUpload,
                        preview: reader.result
                    });
                }
                reader.readAsDataURL(fileUpload);
            }
            else {
                commonApi.showAlert("Please select image only");
                this.refs.file_input.value = '';
            }
        }

    }

    clearFile(event) {
        this.setState({file_upload: undefined})
        this.refs.file_input.value = '';
    }

    handleAttClick(event) {
        this.refs.file_input.value = '';
        this.refs.file_input.click();
    }

    handleComment(event) {
        if (event.key === 'Enter' && uploading == false) {

            var comment = this.state.comment.trim();
            if (comment.length == 0) {
                commonApi.showAlert("Write a comment please!");
            }
            else {
                var data = new FormData();

                data.append('comment', comment);

                if (this.state.file_upload != undefined) {
                    uploading = true;
                    data.append('file', this.state.file_upload);
                }
                if (this.props.feed != undefined) {
                    data.append('id_feed', this.props.feed.id_feed);
                    data.append('feed_type', this.props.feed.feed_type);
                    data.append('id_company', this.props.feed.id_company)
                }
                if (this.props.comment != undefined) {
                    data.append('id_comment', this.props.comment.id_comment);
                }

                var url = '/code/api_feeds.php?api=commentFeeds';
                axios.post(url, data, {
                    progress: (progressEvent) => {
                        progress_val = (progressEvent.loaded / progressEvent.total) * 100;
                        this.forceUpdate();
                    }
                })
                    .then(response => {
                        if (response.data.status == 1) {
                            uploading = false;
                            if (Object.keys(response.data.data).length > 0) {
                                this.setState({comment: "", file_upload: undefined, preview: ""});

                                if (response.data.comment != undefined && Object.keys(response.data.comment).length > 0) {
                                    this.props.onChange(response.data.data);
                                }
                                else {
                                    this.props.onComment(response.data.data);
                                }
                            }
                            else {
                                commonApi.showAlert("Please try again!");
                            }
                        }
                        else {
                            commonApi.showAlert("Please try again!");
                            uploading = false;
                            this.forceUpdate();
                        }
                        //console.log(response.data);

                        return response;
                    }).catch(error => {
                    uploading = false;
                    this.forceUpdate();
                });
            }
        }
    }

    // handleComment(event) {
    //     if (event.key === 'Enter' && uploading == false) {
    //
    //         var comment = this.state.comment.trim();
    //         if (comment.length == 0) {
    //             commonApi.showAlert("Write a comment please!");
    //         }
    //         else {
    //             var data = new FormData();
    //             if (this.state.file_upload != undefined) {
    //                 uploading = true;
    //                 data.append('file', this.state.file_upload);
    //             }
    //             data.append('comment', comment);
    //             var api = commonApi.getAPIURL() + '?api=commentFeedWithImage';
    //             if (this.props.feed.feed_type == 'job_post') {
    //                 api = commonApi.getAPIURL() + '?api=commentJobPostFeedWithImage';
    //             }
    //             if (this.props.feed.feed_type == 'post_feed') {
    //                 api = commonApi.getAPIURL() + '?api=commentPostFeedWithImage';
    //             }
    //             if (this.props.feed != undefined) {
    //                 data.append('id_feed', this.props.feed.id_feed);
    //             }
    //             if (this.props.comment != undefined) {
    //                 data.append('id_comment', this.props.comment.id_comment);
    //                 api = commonApi.getAPIURL() + '?api=replyCommentWithImage'
    //
    //                 if (this.props.feed.feed_type == 'job_post') {
    //                     api = commonApi.getAPIURL() + '?api=replyJobPostCommentWithImage';
    //                 }
    //
    //                 if (this.props.feed.feed_type == 'post_feed') {
    //                     api = commonApi.getAPIURL() + '?api=replyPostCommentWithImage';
    //                 }
    //             }
    //
    //             axios.post(api, data, {
    //                 progress: (progressEvent) => {
    //                     progress_val = (progressEvent.loaded / progressEvent.total) * 100;
    //                     this.forceUpdate();
    //                 }
    //             })
    //                 .then(response => {
    //                     if (response.data.status == 1) {
    //                         uploading = false;
    //                         if (Object.keys(response.data.data).length > 0) {
    //                             this.setState({comment: "", file_upload: undefined, preview: ""});
    //
    //                             if (response.data.comment != undefined && Object.keys(response.data.comment).length > 0) {
    //                                 this.props.onChange(response.data.comment);
    //                             }
    //                             this.props.onComment(response.data.data);
    //                         }
    //                         else {
    //                             commonApi.showAlert("Please try again!");
    //                         }
    //                     }
    //                     else {
    //                         commonApi.showAlert("Please try again!");
    //                         uploading = false;
    //                         this.forceUpdate();
    //                     }
    //                     //console.log(response.data);
    //
    //                     return response;
    //                 }).catch(error => {
    //                 uploading = false;
    //                 this.forceUpdate();
    //             });
    //         }
    //     }
    // }

    handleChange(event) {
        this.setState({comment: event.target.value});
    }

    componentWillReceiveProps(nextProps) {}

    render() {
        var avatar = 'static/img/appimg/common-noavatar-sm.jpg';
        if (this.props.user.image_avatar_account > 0) {
            avatar = this.props.user.link_thumb_file;
        }

        if (this.props.user.id_company > 0) {
            avatar = this.props.user.c_link_thumb_file;
        }
        return (<div>
            {this.props.user != 0 ? (
            <div>
            <div className="post_comment_box">
                <div className="left_box"><img className="img_circle_s" src={avatar}/></div>
                <div className="right_box">
                    <input ref="input" name="post_comment" placeholder="Write a comment..." value={this.state.comment} onChange={this.handleChange.bind(this)} onKeyPress={this.handleComment.bind(this)}/>
                    <a onClick={this.handleAttClick.bind(this)}><img className="att_icon" src="/static/img/appimg/icon_com_att.png"/></a>
                    <div className={this.state.file_upload != undefined ? "file_upload" : "hide-el"}>
                        <img className="img_upload" src={this.state.file_upload != undefined ? this.state.preview : ""}/>
                        <div className="img_close"><a onClick={this.clearFile.bind(this)}>X</a></div>
                    </div>
                </div>
                <div className={uploading ? "upload_progress" : "hide-el"}>
                    <Progress completed={progress_val}/>
                </div>
            </div>
            <input ref="file_input" className="hide-el" type="file" onChange={this.handleFileUpload.bind(this)} accept="image/*"/>
            </div>
            ):""}
        </div>);
    }
}

export default CommentBox;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/course/CommentBox.js
 **/